import { _ as e, b as n, c as t, a0 as r, m as a, a as i, i as o, A as s, aQ as u, aR as c, f as l, h, e as d, u as p, aa as f, U as v, W as C, x as _, y, K as m, w as U, aD as E, z as g, aE as w, ai as T, Q as M, aG as b, t as N, S as P, g as D, aK as H, am as O, V as x, a3 as I, n as A, B as R, an as L } from "./lib/__bundle-75942676.js";
import { q as F, r as S, t as k, w as q, u as z, x as Q, y as K, P as V, z as j, A as B, C as G, E as W, f as X } from "./lib/__bundle-e875840b.js";
import { C as Y, a as Z, O as $, P as J, M as ee, T as ne, R as te, U as re, A as ae, B as ie } from "./lib/__bundle-361d5a90.js";
import { m as oe, c as se } from "./lib/__bundle-84f74e8d.js";
import { P as ue } from "./lib/__bundle-8fdac8b9.js";
import "./lib/__bundle-ad161b2c.js";
var ce = function (r) {
    function a() {
      var e = null !== r && r.apply(this, arguments) || this;
      return e._channels = new Map(), e._enteredChannelUrls = [], e;
    }
    return e(a, r), Object.defineProperty(a.prototype, "enteredChannels", {
      get: function get() {
        var e = this;
        return this._enteredChannelUrls.map(function (n) {
          return e._channels.get(n);
        }).filter(function (e) {
          return !!e;
        });
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.isEnteredChannel = function (e) {
      return this._enteredChannelUrls.includes(e);
    }, a.prototype.enter = function (e) {
      this._enteredChannelUrls.indexOf(e) < 0 && this._enteredChannelUrls.push(e);
    }, a.prototype.exit = function (e) {
      var n = this._enteredChannelUrls.indexOf(e);
      n >= 0 && this._enteredChannelUrls.splice(n, 1);
    }, a.prototype.exitAll = function () {
      this._enteredChannelUrls = [];
    }, a.prototype.get = function (e) {
      return n(this, void 0, void 0, function () {
        return t(this, function (n) {
          return [2, this._channels.get(e)];
        });
      });
    }, a.prototype.upsert = function (e) {
      return n(this, void 0, void 0, function () {
        var n,
          r = this;
        return t(this, function (t) {
          return n = [], e.forEach(function (e) {
            if (r._channels.has(e.url)) {
              var t = r._channels.get(e.url);
              Object.assign(t, e), n.push(t);
            } else r._channels.set(e.url, e), n.push(e);
          }), [2, n];
        });
      });
    }, a.prototype.remove = function (e) {
      return n(this, void 0, void 0, function () {
        return t(this, function (n) {
          return this._channels.delete(e), this.exit(e), [2];
        });
      });
    }, a.prototype.clear = function () {
      return n(this, void 0, void 0, function () {
        return t(this, function (e) {
          return this._channels.clear(), this._enteredChannelUrls = [], [2];
        });
      });
    }, a;
  }(r),
  le = {
    channelUrl: void 0,
    name: void 0,
    coverUrlOrImage: void 0,
    data: void 0,
    customType: void 0,
    operatorUserIds: void 0,
    isEphemeral: void 0
  },
  he = function (n) {
    function t(e) {
      var t = e.channelUrl,
        r = e.isInternalCall,
        a = n.call(this) || this;
      return a.method = s.GET, a.path = "".concat(r ? u : c, "/").concat(encodeURIComponent(t)), a;
    }
    return e(t, n), t;
  }(l),
  de = function (n) {
    function t(e, t) {
      var r = n.call(this, e, t) || this;
      return r.channel = new Ne(e, t), r;
    }
    return e(t, n), t;
  }(h),
  pe = function (n) {
    function t(e) {
      var t = this,
        r = e.channelUrl,
        a = e.coverUrlOrImage,
        u = e.name,
        l = e.data,
        h = e.customType,
        f = e.operatorUserIds,
        v = e.isEphemeral;
      return (t = n.call(this) || this).method = s.POST, t.path = c, t.params = d(p({
        channel_url: r,
        cover_url: i("string", a) ? a : null,
        cover_file: o(a) ? a : null,
        name: u,
        data: l,
        custom_type: h,
        operators: f,
        is_ephemeral: v
      })), t;
    }
    return e(t, n), t;
  }(l);
!function (n) {
  function t(e, t) {
    var r = n.call(this, e, t) || this;
    return r.channel = new Ne(e, t), r;
  }
  e(t, n);
}(h);
var fe = function (n) {
    function t(e) {
      var t = e.channelUrl;
      return n.call(this, {
        code: "ENTR",
        payload: {
          channel_url: t
        },
        ackRequired: !0
      }) || this;
    }
    return e(t, n), t;
  }(f),
  ve = function (n) {
    function t(e, t, r) {
      var a,
        i,
        o = this;
      return o = n.call(this, e, "SYEV", r) || this, r.data && (o.participantCount = null !== (a = r.data.participant_count) && void 0 !== a ? a : 0, o.user = new v(e, r.data), o.ts = null !== (i = r.data.edge_ts) && void 0 !== i ? i : 0), o;
    }
    return e(t, n), t;
  }(Y),
  Ce = function (n) {
    function t(e) {
      var t = e.channelUrl;
      return n.call(this, {
        code: "EXIT",
        payload: {
          channel_url: t
        },
        ackRequired: !0
      }) || this;
    }
    return e(t, n), t;
  }(f),
  _e = function (n) {
    function t(e, t, r) {
      var a,
        i,
        o = this;
      return o = n.call(this, e, "EXIT", r) || this, r.data && (o.participantCount = null !== (a = r.data.participant_count) && void 0 !== a ? a : 0, o.user = new v(e, r.data), o.ts = null !== (i = r.data.edge_ts) && void 0 !== i ? i : 0), o;
    }
    return e(t, n), t;
  }(Y),
  ye = {},
  me = function () {
    function e(e, n) {
      var t = n.sdkState,
        r = n.dispatcher,
        a = n.requestQueue,
        i = this;
      return ye[e] || (this._iid = e, this._sdkState = t, this._requestQueue = a, this._dispatcher = r, this._openChannelCache = new ce(e), this._openChannelHandlers = new Map(), this._dispatcher.on(function (e) {
        var n, t;
        if (e instanceof C) i._handleEvent(e);else if (e instanceof _ && e.stateType === y.CONNECTED) {
          var r = i._openChannelCache.enteredChannels;
          try {
            for (var a = m(r), o = a.next(); !o.done; o = a.next()) {
              o.value.enter();
            }
          } catch (e) {
            n = {
              error: e
            };
          } finally {
            try {
              o && !o.done && (t = a.return) && t.call(a);
            } finally {
              if (n) throw n.error;
            }
          }
        }
      }), ye[e] = this), ye[e];
    }
    return e.of = function (e) {
      return ye[e];
    }, e.prototype.buildOpenChannelFromSerializedData = function (e) {
      var n = U(e);
      return new Ne(this._iid, Ne.payloadify(n));
    }, e.prototype.getChannelFromCache = function (e) {
      var r;
      return n(this, void 0, void 0, function () {
        return t(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this._openChannelCache.get(e)];
            case 1:
              return [2, null !== (r = n.sent()) && void 0 !== r ? r : null];
          }
        });
      });
    }, e.prototype.upsertChannelsToCache = function (e) {
      return n(this, void 0, void 0, function () {
        return t(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this._openChannelCache.upsert(e)];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, e.prototype.removeChannelsFromCache = function (e) {
      return n(this, void 0, void 0, function () {
        var n, r, a, i, o, s;
        return t(this, function (t) {
          switch (t.label) {
            case 0:
              t.trys.push([0, 5, 6, 7]), n = m(e), r = n.next(), t.label = 1;
            case 1:
              return r.done ? [3, 4] : (a = r.value, [4, this._openChannelCache.remove(a)]);
            case 2:
              t.sent(), t.label = 3;
            case 3:
              return r = n.next(), [3, 1];
            case 4:
              return [3, 7];
            case 5:
              return i = t.sent(), o = {
                error: i
              }, [3, 7];
            case 6:
              try {
                r && !r.done && (s = n.return) && s.call(n);
              } finally {
                if (o) throw o.error;
              }
              return [7];
            case 7:
              return [2];
          }
        });
      });
    }, e.prototype.setEnteredToCache = function (e) {
      this._openChannelCache.enter(e.url);
    }, e.prototype.setExitedToCache = function (e) {
      this._openChannelCache.exit(e.url);
    }, e.prototype._handleEvent = function (e) {
      return n(this, void 0, void 0, function () {
        var r,
          a,
          i,
          o,
          s,
          u,
          c,
          l,
          h,
          d,
          p,
          f,
          v,
          C,
          _,
          y,
          U,
          N,
          P,
          D,
          O,
          x,
          I,
          A,
          R,
          L,
          X,
          ie,
          se,
          ue,
          ce,
          le,
          he,
          de,
          pe,
          fe,
          Ce,
          ye,
          me,
          Ue,
          Ee,
          ge,
          we,
          Te,
          Me,
          be,
          Ne,
          Pe,
          De,
          He,
          Oe,
          xe,
          Ie,
          Ae,
          Re,
          Le,
          Fe,
          Se,
          ke,
          qe,
          ze,
          Qe,
          Ke,
          Ve,
          je,
          Be,
          Ge,
          We,
          Xe = this;
        return t(this, function (Ye) {
          switch (Ye.label) {
            case 0:
              switch (Ye.trys.push([0, 57,, 58]), e.code) {
                case "MESG":
                case "FILE":
                case "ADMM":
                case "BRDM":
                  return [3, 1];
                case "MEDI":
                case "FEDI":
                case "AEDI":
                  return [3, 4];
                case "DELM":
                  return [3, 7];
                case "MRCT":
                  return [3, 10];
                case "MTHD":
                  return [3, 13];
                case "MCNT":
                  return [3, 16];
                case "PEDI":
                  return [3, 27];
                case "VOTE":
                  return [3, 30];
                case "SYEV":
                  return [3, 33];
              }
              return [3, 56];
            case 1:
              return o = null, "MESG" === e.code ? o = e.as(W) : "FILE" === e.code ? o = e.as(oe) : "ADMM" !== e.code && "BRDM" != e.code || (o = e.as(ae)), o ? (r = o.message, a = o.isMentioned, r.channelType !== M.OPEN ? [3, 3] : [4, this.getChannel(r.channelUrl, !0)]) : [3, 3];
            case 2:
              i = Ye.sent(), g(function () {
                return n(Xe, void 0, void 0, function () {
                  var e, n, o, s, u;
                  return t(this, function (t) {
                    try {
                      for (e = m(this._openChannelHandlers.values()), n = e.next(); !n.done; n = e.next()) o = n.value, this._openChannelCache.isEnteredChannel(i.url) && (o.onMessageReceived && o.onMessageReceived(i, r), a && o.onMentionReceived && o.onMentionReceived(i, r));
                    } catch (e) {
                      s = {
                        error: e
                      };
                    } finally {
                      try {
                        n && !n.done && (u = e.return) && u.call(e);
                      } finally {
                        if (s) throw s.error;
                      }
                    }
                    return [2];
                  });
                });
              }), Ye.label = 3;
            case 3:
              return [3, 56];
            case 4:
              return o = null, "MEDI" === e.code ? o = e.as(B) : "FEDI" === e.code ? o = e.as(G) : "AEDI" === e.code && (o = e.as(re)), o ? (s = o.message, u = o.mentionCountChange, s.channelType !== M.OPEN ? [3, 6] : [4, this.getChannel(s.channelUrl, !0)]) : [3, 6];
            case 5:
              c = Ye.sent(), g(function () {
                return n(Xe, void 0, void 0, function () {
                  var e, n, r, a, i;
                  return t(this, function (t) {
                    try {
                      for (e = m(this._openChannelHandlers.values()), n = e.next(); !n.done; n = e.next()) r = n.value, this._openChannelCache.isEnteredChannel(c.url) && (r.onMessageUpdated && r.onMessageUpdated(c, s), u > 0 && r.onMentionReceived && r.onMentionReceived(c, s));
                    } catch (e) {
                      a = {
                        error: e
                      };
                    } finally {
                      try {
                        n && !n.done && (i = e.return) && i.call(e);
                      } finally {
                        if (a) throw a.error;
                      }
                    }
                    return [2];
                  });
                });
              }), Ye.label = 6;
            case 6:
              return [3, 56];
            case 7:
              return l = e.as(j), ce = l.channelUrl, le = l.channelType, h = l.messageId, le !== M.OPEN ? [3, 9] : [4, this.getChannel(ce, !0)];
            case 8:
              d = Ye.sent(), g(function () {
                return n(Xe, void 0, void 0, function () {
                  var e, n, r, a, i;
                  return t(this, function (t) {
                    try {
                      for (e = m(this._openChannelHandlers.values()), n = e.next(); !n.done; n = e.next()) r = n.value, this._openChannelCache.isEnteredChannel(d.url) && r.onMessageDeleted && r.onMessageDeleted(d, h);
                    } catch (e) {
                      a = {
                        error: e
                      };
                    } finally {
                      try {
                        n && !n.done && (i = e.return) && i.call(e);
                      } finally {
                        if (a) throw a.error;
                      }
                    }
                    return [2];
                  });
                });
              }), Ye.label = 9;
            case 9:
              return [3, 56];
            case 10:
              return p = e.as(te), ce = p.channelUrl, le = p.channelType, f = p.event, le !== M.OPEN ? [3, 12] : [4, this.getChannel(ce, !0)];
            case 11:
              v = Ye.sent(), g(function () {
                return n(Xe, void 0, void 0, function () {
                  var e, n, r, a, i;
                  return t(this, function (t) {
                    try {
                      for (e = m(this._openChannelHandlers.values()), n = e.next(); !n.done; n = e.next()) r = n.value, this._openChannelCache.isEnteredChannel(v.url) && r.onReactionUpdated && r.onReactionUpdated(v, f);
                    } catch (e) {
                      a = {
                        error: e
                      };
                    } finally {
                      try {
                        n && !n.done && (i = e.return) && i.call(e);
                      } finally {
                        if (a) throw a.error;
                      }
                    }
                    return [2];
                  });
                });
              }), Ye.label = 12;
            case 12:
              return [3, 56];
            case 13:
              return (C = e.as(ne).event).channelType !== M.OPEN ? [3, 15] : [4, this.getChannel(C.channelUrl, !0)];
            case 14:
              _ = Ye.sent(), g(function () {
                return n(Xe, void 0, void 0, function () {
                  var e, n, r, a, i;
                  return t(this, function (t) {
                    try {
                      for (e = m(this._openChannelHandlers.values()), n = e.next(); !n.done; n = e.next()) r = n.value, this._openChannelCache.isEnteredChannel(_.url) && r.onThreadInfoUpdated && r.onThreadInfoUpdated(_, C);
                    } catch (e) {
                      a = {
                        error: e
                      };
                    } finally {
                      try {
                        n && !n.done && (i = e.return) && i.call(e);
                      } finally {
                        if (a) throw a.error;
                      }
                    }
                    return [2];
                  });
                });
              }), Ye.label = 15;
            case 15:
              return [3, 56];
            case 16:
              y = e.as(ee).openChannelMemberCounts, U = [], Ye.label = 17;
            case 17:
              Ye.trys.push([17, 22, 23, 24]), N = m(y), P = N.next(), Ye.label = 18;
            case 18:
              return P.done ? [3, 21] : (D = P.value, ce = D.channelUrl, Ee = D.participantCount, O = D.updatedAt, [4, this.getChannelFromCache(ce)]);
            case 19:
              (x = Ye.sent()) && x._updateParticipantCount(Ee, O) && U.push(x), Ye.label = 20;
            case 20:
              return P = N.next(), [3, 18];
            case 21:
              return [3, 24];
            case 22:
              return I = Ye.sent(), Ge = {
                error: I
              }, [3, 24];
            case 23:
              try {
                P && !P.done && (We = N.return) && We.call(N);
              } finally {
                if (Ge) throw Ge.error;
              }
              return [7];
            case 24:
              return U.length > 0 ? [4, this.upsertChannelsToCache(U)] : [3, 26];
            case 25:
              A = Ye.sent(), g(function () {
                return n(Xe, void 0, void 0, function () {
                  var e, n, r, a, i;
                  return t(this, function (t) {
                    try {
                      for (e = m(this._openChannelHandlers.values()), n = e.next(); !n.done; n = e.next()) (r = n.value).onChannelMemberCountChanged && r.onChannelMemberCountChanged(A);
                    } catch (e) {
                      a = {
                        error: e
                      };
                    } finally {
                      try {
                        n && !n.done && (i = e.return) && i.call(e);
                      } finally {
                        if (a) throw a.error;
                      }
                    }
                    return [2];
                  });
                });
              }), Ye.label = 26;
            case 26:
              return [3, 56];
            case 27:
              return R = e.as(J), L = R.event, X = R.status, ce = R.channelUrl, le = R.channelType, ce && le === M.OPEN ? [4, this.getChannel(ce, !0)] : [3, 29];
            case 28:
              ie = Ye.sent(), this._dispatcher.dispatch(new b({
                event: L,
                source: T.EVENT_POLL_UPDATED
              })), g(X === H ? function () {
                return n(Xe, void 0, void 0, function () {
                  var e, n, r, a, i;
                  return t(this, function (t) {
                    try {
                      for (e = m(this._openChannelHandlers.values()), n = e.next(); !n.done; n = e.next()) (r = n.value).onPollDeleted && r.onPollDeleted(ie, L.pollId);
                    } catch (e) {
                      a = {
                        error: e
                      };
                    } finally {
                      try {
                        n && !n.done && (i = e.return) && i.call(e);
                      } finally {
                        if (a) throw a.error;
                      }
                    }
                    return [2];
                  });
                });
              } : function () {
                return n(Xe, void 0, void 0, function () {
                  var e, n, r, a, i;
                  return t(this, function (t) {
                    try {
                      for (e = m(this._openChannelHandlers.values()), n = e.next(); !n.done; n = e.next()) (r = n.value).onPollUpdated && r.onPollUpdated(ie, L);
                    } catch (e) {
                      a = {
                        error: e
                      };
                    } finally {
                      try {
                        n && !n.done && (i = e.return) && i.call(e);
                      } finally {
                        if (a) throw a.error;
                      }
                    }
                    return [2];
                  });
                });
              }), Ye.label = 29;
            case 29:
              return [3, 56];
            case 30:
              return se = e.as(V), ue = se.event, ce = se.channelUrl, le = se.channelType, ce && le === M.OPEN ? [4, this.getChannel(ce, !0)] : [3, 32];
            case 31:
              he = Ye.sent(), this._dispatcher.dispatch(new w({
                event: ue,
                source: T.EVENT_POLL_VOTED
              })), g(function () {
                return n(Xe, void 0, void 0, function () {
                  var e, n, r, a, i;
                  return t(this, function (t) {
                    try {
                      for (e = m(this._openChannelHandlers.values()), n = e.next(); !n.done; n = e.next()) (r = n.value).onPollVoted && r.onPollVoted(he, ue);
                    } catch (e) {
                      a = {
                        error: e
                      };
                    } finally {
                      try {
                        n && !n.done && (i = e.return) && i.call(e);
                      } finally {
                        if (a) throw a.error;
                      }
                    }
                    return [2];
                  });
                });
              }), Ye.label = 32;
            case 32:
              return [3, 56];
            case 33:
              if (!(de = e.as(Y).event).isOpenChannelEvent) return [3, 55];
              switch (de.category) {
                case Z.CHANNEL_ENTER:
                  return [3, 34];
                case Z.CHANNEL_EXIT:
                  return [3, 36];
                case Z.CHANNEL_OPERATOR_UPDATE:
                  return [3, 38];
                case Z.USER_CHANNEL_MUTE:
                case Z.USER_CHANNEL_UNMUTE:
                  return [3, 40];
                case Z.USER_CHANNEL_BAN:
                case Z.USER_CHANNEL_UNBAN:
                  return [3, 42];
                case Z.CHANNEL_FREEZE:
                case Z.CHANNEL_UNFREEZE:
                  return [3, 44];
                case Z.CHANNEL_DELETED:
                  return [3, 46];
                case Z.CHANNEL_PROP_CHANGED:
                  return [3, 49];
                case Z.CHANNEL_META_DATA_CHANGED:
                  return [3, 51];
                case Z.CHANNEL_META_COUNTERS_CHANGED:
                  return [3, 53];
              }
              return [3, 55];
            case 34:
              return [4, this.getChannel(de.channelUrl, !0)];
            case 35:
              return pe = Ye.sent(), fe = e.as(ve), Ee = fe.participantCount, Ce = fe.user, ye = pe._updateParticipantCount(Ee, de.ts), g(function () {
                return n(Xe, void 0, void 0, function () {
                  return t(this, function (e) {
                    return this._openChannelHandlers.forEach(function (e) {
                      e.onUserEntered && e.onUserEntered(pe, Ce), ye && e.onChannelParticipantCountChanged && e.onChannelParticipantCountChanged(pe);
                    }), [2];
                  });
                });
              }), [3, 55];
            case 36:
              return [4, this.getChannel(de.channelUrl, !0)];
            case 37:
              return me = Ye.sent(), Ue = e.as(_e), Ee = Ue.participantCount, ge = Ue.user, we = me._updateParticipantCount(Ee, de.ts), g(function () {
                return n(Xe, void 0, void 0, function () {
                  return t(this, function (e) {
                    return this._openChannelHandlers.forEach(function (e) {
                      e.onUserExited && e.onUserExited(me, ge), we && e.onChannelParticipantCountChanged && e.onChannelParticipantCountChanged(me);
                    }), [2];
                  });
                });
              }), [3, 55];
            case 38:
              return [4, this.getChannel(de.channelUrl, !0)];
            case 39:
              return Te = Ye.sent(), Me = e.as($).operators, Te.operators = Me, this.upsertChannelsToCache([Te]), g(function () {
                return n(Xe, void 0, void 0, function () {
                  return t(this, function (e) {
                    return this._openChannelHandlers.forEach(function (e) {
                      e.onOperatorUpdated && e.onOperatorUpdated(Te, Me);
                    }), [2];
                  });
                });
              }), [3, 55];
            case 40:
              return [4, this.getChannel(de.channelUrl, !0)];
            case 41:
              return be = Ye.sent(), Ne = de.category === Z.USER_CHANNEL_MUTE, Pe = e.as(Ne ? Q : K).user, g(function () {
                return n(Xe, void 0, void 0, function () {
                  return t(this, function (e) {
                    return this._openChannelHandlers.forEach(function (e) {
                      Ne ? e.onUserMuted && e.onUserMuted(be, Pe) : e.onUserUnmuted && e.onUserUnmuted(be, Pe);
                    }), [2];
                  });
                });
              }), [3, 55];
            case 42:
              return [4, this.getChannel(de.channelUrl, !0)];
            case 43:
              return De = Ye.sent(), He = de.category === Z.USER_CHANNEL_BAN, Oe = e.as(He ? q : z).user, g(function () {
                return n(Xe, void 0, void 0, function () {
                  return t(this, function (e) {
                    return this._openChannelHandlers.forEach(function (e) {
                      He ? e.onUserBanned && e.onUserBanned(De, Oe) : e.onUserUnbanned && e.onUserUnbanned(De, Oe);
                    }), [2];
                  });
                });
              }), [3, 55];
            case 44:
              return [4, this.getChannel(de.channelUrl, !0)];
            case 45:
              return xe = Ye.sent(), Ie = e.as(k).freeze, xe.isFrozen = Ie, this.upsertChannelsToCache([xe]), g(function () {
                return n(Xe, void 0, void 0, function () {
                  return t(this, function (e) {
                    return this._openChannelHandlers.forEach(function (e) {
                      Ie ? e.onChannelFrozen && e.onChannelFrozen(xe) : e.onChannelUnfrozen && e.onChannelUnfrozen(xe);
                    }), [2];
                  });
                });
              }), [3, 55];
            case 46:
              return [4, this.getChannel(de.channelUrl, !0)];
            case 47:
              return Ae = Ye.sent(), [4, this.removeChannelsFromCache([Ae.url])];
            case 48:
              return Ye.sent(), g(function () {
                return n(Xe, void 0, void 0, function () {
                  return t(this, function (e) {
                    return this._openChannelHandlers.forEach(function (e) {
                      e.onChannelDeleted && e.onChannelDeleted(Ae.url, Ae.channelType);
                    }), [2];
                  });
                });
              }), [3, 55];
            case 49:
              return [4, this.getChannelWithoutCache(de.channelUrl, !0)];
            case 50:
              return Re = Ye.sent(), g(function () {
                return n(Xe, void 0, void 0, function () {
                  return t(this, function (e) {
                    return this._openChannelHandlers.forEach(function (e) {
                      e.onChannelChanged && e.onChannelChanged(Re);
                    }), [2];
                  });
                });
              }), [3, 55];
            case 51:
              return [4, this.getChannel(de.channelUrl, !0)];
            case 52:
              return Le = Ye.sent(), Fe = e.as(S), Se = Fe.created, ke = Fe.updated, qe = Fe.deleted, Se && Le._upsertCachedMetaData(Se, de.ts), ke && Le._upsertCachedMetaData(ke, de.ts), qe && Le._removeFromCachedMetaData(qe, de.ts), g(function () {
                return n(Xe, void 0, void 0, function () {
                  return t(this, function (e) {
                    return this._openChannelHandlers.forEach(function (e) {
                      Se && e.onMetaDataCreated && e.onMetaDataCreated(Le, Se), ke && e.onMetaDataUpdated && e.onMetaDataUpdated(Le, ke), qe && e.onMetaDataDeleted && e.onMetaDataDeleted(Le, qe);
                    }), [2];
                  });
                });
              }), [3, 55];
            case 53:
              return [4, this.getChannel(de.channelUrl, !0)];
            case 54:
              return ze = Ye.sent(), Qe = e.as(F), Ke = Qe.created, Ve = Qe.updated, je = Qe.deleted, g(function () {
                return n(Xe, void 0, void 0, function () {
                  return t(this, function (e) {
                    return this._openChannelHandlers.forEach(function (e) {
                      Ke && e.onMetaCounterCreated && e.onMetaCounterCreated(ze, Ke), Ve && e.onMetaCounterUpdated && e.onMetaCounterUpdated(ze, Ve), je && e.onMetaCounterDeleted && e.onMetaCounterDeleted(ze, je);
                    }), [2];
                  });
                });
              }), [3, 55];
            case 55:
              return [3, 56];
            case 56:
              return [3, 58];
            case 57:
              if (Be = Ye.sent(), E(Be)) throw Be;
              return [3, 58];
            case 58:
              return [2];
          }
        });
      });
    }, e.prototype.addHandler = function (e, n) {
      this._openChannelHandlers.set(e, n);
    }, e.prototype.removeHandler = function (e) {
      this._openChannelHandlers.delete(e);
    }, e.prototype.clearHandler = function () {
      this._openChannelHandlers.clear();
    }, e.prototype.getChannel = function (e, r) {
      return n(this, void 0, void 0, function () {
        var n;
        return t(this, function (t) {
          switch (t.label) {
            case 0:
              N(i("string", e)).throw(P.invalidParameters), t.label = 1;
            case 1:
              return t.trys.push([1, 3,, 4]), [4, this.getChannelFromCache(e)];
            case 2:
              return (n = t.sent()) ? [2, n] : [3, 4];
            case 3:
              return t.sent(), [3, 4];
            case 4:
              return [4, this.getChannelWithoutCache(e)];
            case 5:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype.getChannelWithoutCache = function (e, r) {
      return void 0 === r && (r = !1), n(this, void 0, void 0, function () {
        var n, a, o;
        return t(this, function (t) {
          switch (t.label) {
            case 0:
              return N(i("string", e)).throw(P.invalidParameters), n = new he({
                channelUrl: e,
                isInternalCall: r
              }), [4, this._requestQueue.send(n)];
            case 1:
              return a = t.sent(), o = a.as(de).channel, [4, this.upsertChannelsToCache([o])];
            case 2:
              return [2, t.sent()[0]];
          }
        });
      });
    }, e.prototype.createChannel = function (e) {
      return n(this, void 0, void 0, function () {
        var n, r, s, u;
        return t(this, function (t) {
          switch (t.label) {
            case 0:
              return n = D(D({}, le), e), N(function (e) {
                return a("string", e.operatorUserIds, !0) && (i("string", e.coverUrlOrImage, !0) || o(e.coverUrlOrImage, !0)) && i("string", e.name, !0) && i("string", e.data, !0) && i("string", e.customType, !0) && (i("string", e.channelUrl) && /^\w+$/.test(e.channelUrl) || null === e.channelUrl || void 0 === e.channelUrl) && i("boolean", e.isEphemeral, !0);
              }(n)).throw(P.invalidParameters), r = new pe(n), [4, this._requestQueue.send(r)];
            case 1:
              return s = t.sent(), u = s.as(de).channel, this.upsertChannelsToCache([u]), [2, u];
          }
        });
      });
    }, e;
  }(),
  Ue = {
    name: void 0,
    coverUrlOrImage: void 0,
    data: void 0,
    customType: void 0,
    operatorUserIds: void 0
  },
  Ee = function (n) {
    function t(e) {
      var t = this,
        r = e.channelUrl,
        a = e.token,
        i = e.limit;
      return (t = n.call(this) || this).method = s.GET, t.path = "".concat(c, "/").concat(encodeURIComponent(r), "/participants"), t.params = {
        token: a,
        limit: i
      }, t;
    }
    return e(t, n), t;
  }(l),
  ge = function (n) {
    function t(e, t) {
      var r = n.call(this, e, t) || this;
      r.participants = [];
      var a = t.next,
        i = t.participants;
      return r.token = a, r.participants = i.map(function (n) {
        return new ue(e, n);
      }), r;
    }
    return e(t, n), t;
  }(h),
  we = function (r) {
    function a(e, n, t) {
      return r.call(this, e, n, M.OPEN, t) || this;
    }
    return e(a, r), a.prototype._validate = function () {
      return r.prototype._validate.call(this);
    }, a.prototype.next = function () {
      return n(this, void 0, void 0, function () {
        var e, n, r, a, i, o;
        return t(this, function (t) {
          switch (t.label) {
            case 0:
              return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = x.of(this._iid).requestQueue, n = new Ee(D(D({}, this), {
                token: this._token
              })), [4, e.send(n)]) : [3, 2] : [3, 5];
            case 1:
              return r = t.sent(), a = r.as(ge), i = a.participants, o = a.token, this._token = o, this._hasNext = !!o, this._isLoading = !1, [2, i];
            case 2:
              return [2, []];
            case 3:
              throw P.queryInProgress;
            case 4:
              return [3, 6];
            case 5:
              throw P.invalidParameters;
            case 6:
              return [2];
          }
        });
      });
    }, a;
  }(O),
  Te = function (n) {
    function t(e) {
      var t = this,
        r = e.channelUrl,
        a = e.coverUrlOrImage,
        u = e.name,
        l = e.data,
        h = e.customType,
        f = e.operatorUserIds;
      return (t = n.call(this) || this).method = s.PUT, t.path = "".concat(c, "/").concat(encodeURIComponent(r)), t.params = d(p({
        cover_url: i("string", a) ? a : null,
        cover_file: o(a) ? a : null,
        name: u,
        data: l,
        custom_type: h,
        operators: f
      })), t;
    }
    return e(t, n), t;
  }(l),
  Me = function (n) {
    function t(e, t) {
      var r = n.call(this, e, t) || this;
      return r.channel = new Ne(e, t), r;
    }
    return e(t, n), t;
  }(h),
  be = function (n) {
    function t(e) {
      var t = this,
        r = e.channelUrl;
      return (t = n.call(this) || this).method = s.DELETE, t.path = "".concat(c, "/").concat(encodeURIComponent(r)), t;
    }
    return e(t, n), t;
  }(l);
!function (n) {
  function t(e, t) {
    return n.call(this, e, t) || this;
  }
  e(t, n);
}(h);
var Ne = function (r) {
    function s(e, n) {
      var t,
        a = this;
      return (a = r.call(this, e, n) || this)._lastParticipantCountUpdated = 0, a.participantCount = 0, a.operators = [], a.channelType = M.OPEN, a.participantCount = null !== (t = n.participant_count) && void 0 !== t ? t : 0, a.operators = Array.isArray(n.operators) ? n.operators.map(function (n) {
        return new v(e, n);
      }) : [], a;
    }
    return e(s, r), s.payloadify = function (e) {
      return d(p(D(D({}, X.payloadify(e)), {
        participant_count: e.participantCount,
        operators: e.operators.map(function (e) {
          return v.payloadify(e);
        })
      })));
    }, s.prototype.serialize = function () {
      return I(this);
    }, s.prototype.isOperator = function (e) {
      return e instanceof v ? this.isOperator(e.userId) : this.operators.some(function (n) {
        return n.userId === e;
      });
    }, s.prototype._updateParticipantCount = function (e, n) {
      return n > this._lastParticipantCountUpdated && (this.participantCount = e, this._lastParticipantCountUpdated = n, !0);
    }, s.prototype.createParticipantListQuery = function (e) {
      return new we(this._iid, this.url, e);
    }, s.prototype.refresh = function () {
      return n(this, void 0, void 0, function () {
        return t(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, me.of(this._iid).getChannelWithoutCache(this.url)];
            case 1:
              return [2, e.sent()];
          }
        });
      });
    }, s.prototype.enter = function () {
      return n(this, void 0, void 0, function () {
        var e, n, r, a, i, o;
        return t(this, function (t) {
          switch (t.label) {
            case 0:
              return e = x.of(this._iid).requestQueue, n = new fe({
                channelUrl: this.url
              }), [4, e.send(n)];
            case 1:
              return r = t.sent(), a = r.as(ve), i = a.participantCount, o = a.ts, this._updateParticipantCount(i, o), me.of(this._iid).setEnteredToCache(this), [2];
          }
        });
      });
    }, s.prototype.exit = function () {
      return n(this, void 0, void 0, function () {
        var e, n, r, a, i, o;
        return t(this, function (t) {
          switch (t.label) {
            case 0:
              return e = x.of(this._iid).requestQueue, n = new Ce({
                channelUrl: this.url
              }), [4, e.send(n)];
            case 1:
              return r = t.sent(), a = r.as(_e), i = a.participantCount, o = a.ts, this._updateParticipantCount(i, o), me.of(this._iid).setExitedToCache(this), se.of(this._iid).fileMessageQueue.cancel(this), [2];
          }
        });
      });
    }, s.prototype.updateChannel = function (e) {
      return n(this, void 0, void 0, function () {
        var n, r, s, u, c;
        return t(this, function (t) {
          switch (t.label) {
            case 0:
              return n = D(D({}, Ue), e), N(function (e) {
                return a("string", e.operatorUserIds, !0) && (i("string", e.coverUrlOrImage) || o(e.coverUrlOrImage) || null === e.coverUrlOrImage) && i("string", e.name, !0) && i("string", e.data, !0) && i("string", e.customType, !0);
              }(n)).throw(P.invalidParameters), r = x.of(this._iid).requestQueue, s = new Te(D({
                channelUrl: this.url
              }, n)), [4, r.send(s)];
            case 1:
              return u = t.sent(), c = u.as(Me).channel, this._update(c), [4, me.of(this._iid).upsertChannelsToCache([c])];
            case 2:
              return t.sent(), [2, this];
          }
        });
      });
    }, s.prototype.updateChannelWithOperatorUserIds = function (e, r, a, i, o) {
      return n(this, void 0, void 0, function () {
        var n;
        return t(this, function (t) {
          return n = D(D({}, Ue), {
            name: e,
            coverUrlOrImage: r,
            data: a,
            operatorUserIds: i,
            customType: o
          }), [2, this.updateChannel(n)];
        });
      });
    }, s.prototype.delete = function () {
      return n(this, void 0, void 0, function () {
        var e, n;
        return t(this, function (t) {
          switch (t.label) {
            case 0:
              return e = x.of(this._iid).requestQueue, n = new be({
                channelUrl: this.url
              }), [4, e.send(n)];
            case 1:
              return t.sent(), [4, me.of(this._iid).removeChannelsFromCache([this.url])];
            case 2:
              return t.sent(), [2];
          }
        });
      });
    }, s.prototype.sendUserMessage = function (e) {
      return N(!e.isPinnedMessage).throw(P.notSupportedError), r.prototype.sendUserMessage.call(this, e);
    }, s.prototype.sendFileMessage = function (e) {
      return N(!e.isPinnedMessage).throw(P.notSupportedError), r.prototype.sendFileMessage.call(this, e);
    }, s;
  }(X),
  Pe = function (n) {
    function t(e) {
      void 0 === e && (e = {});
      var t = n.call(this) || this;
      return Object.keys(e).forEach(function (n) {
        t.hasOwnProperty(n) && (t[n] = e[n]);
      }), t;
    }
    return e(t, n), t;
  }(function (n) {
    function t() {
      var e = null !== n && n.apply(this, arguments) || this;
      return e.onUserEntered = A, e.onUserExited = A, e.onChannelParticipantCountChanged = A, e.onPollUpdated = A, e.onPollVoted = A, e.onPollDeleted = A, e;
    }
    return e(t, n), t;
  }(ie)),
  De = function (n) {
    function t(e) {
      var t = this,
        r = e.token,
        a = e.limit,
        i = e.nameKeyword,
        o = e.urlKeyword,
        u = e.customTypes,
        l = e.includeFrozen,
        h = e.includeMetaData;
      return (t = n.call(this) || this).method = s.GET, t.path = c, t.params = d({
        token: r,
        limit: a,
        name_contains: i,
        url_contains: o,
        custom_types: u,
        show_frozen: l,
        show_metadata: h
      }), t;
    }
    return e(t, n), t;
  }(l),
  He = function (n) {
    function t(e, t) {
      var r = n.call(this, e, t) || this;
      r.channels = [];
      var a = t.next,
        i = t.channels,
        o = t.ts;
      return r.token = a, i && i.length > 0 && (r.channels = i.map(function (n) {
        return new Ne(e, n);
      })), r.ts = "number" == typeof o ? o : null, r;
    }
    return e(t, n), t;
  }(h),
  Oe = function (r) {
    function o(e, n) {
      var t,
        a,
        i,
        o,
        s,
        u = this;
      return (u = r.call(this, e, n) || this).includeFrozen = !0, u.includeMetaData = !0, u.nameKeyword = null, u.urlKeyword = null, u.customTypes = null, u.includeFrozen = null === (t = n.includeFrozen) || void 0 === t || t, u.includeMetaData = null === (a = n.includeMetaData) || void 0 === a || a, u.nameKeyword = null !== (i = n.nameKeyword) && void 0 !== i ? i : null, u.urlKeyword = null !== (o = n.urlKeyword) && void 0 !== o ? o : null, u.customTypes = null !== (s = n.customTypes) && void 0 !== s ? s : null, u;
    }
    return e(o, r), o.prototype._validate = function () {
      return r.prototype._validate.call(this) && i("boolean", this.includeFrozen) && i("boolean", this.includeMetaData) && i("string", this.nameKeyword, !0) && i("string", this.urlKeyword, !0) && a("string", this.customTypes, !0);
    }, o.prototype.next = function () {
      return n(this, void 0, void 0, function () {
        var e, n, r, a, i, o;
        return t(this, function (t) {
          switch (t.label) {
            case 0:
              return this._validate() ? this._isLoading ? [3, 4] : this._hasNext ? (this._isLoading = !0, e = x.of(this._iid).requestQueue, n = new De(p(D(D({}, this), {
                token: this._token
              }))), [4, e.send(n)]) : [3, 3] : [3, 6];
            case 1:
              return r = t.sent(), a = r.as(He), i = a.channels, o = a.token, this._token = o, this._hasNext = !!o, [4, me.of(this._iid).upsertChannelsToCache(i)];
            case 2:
              return t.sent(), this._isLoading = !1, [2, i];
            case 3:
              return [2, []];
            case 4:
              throw P.queryInProgress;
            case 5:
              return [3, 7];
            case 6:
              throw P.invalidParameters;
            case 7:
              return [2];
          }
        });
      });
    }, o;
  }(R),
  xe = function (r) {
    function a() {
      var e = null !== r && r.apply(this, arguments) || this;
      return e.name = "openChannel", e;
    }
    return e(a, r), a.prototype.init = function (e, n) {
      var t = n.sdkState,
        a = n.dispatcher,
        i = n.sessionManager,
        o = n.requestQueue,
        s = n.logger,
        u = n.onlineDetector,
        c = n.cacheContext;
      r.prototype.init.call(this, e, {
        sdkState: t,
        dispatcher: a,
        sessionManager: i,
        requestQueue: o,
        logger: s,
        onlineDetector: u,
        cacheContext: c
      }), this._manager = new me(e, {
        sdkState: t,
        dispatcher: a,
        requestQueue: o
      });
    }, a.prototype.createOpenChannelListQuery = function (e) {
      return void 0 === e && (e = {}), new Oe(this._iid, e);
    }, a.prototype.addOpenChannelHandler = function (e, n) {
      this._manager.addHandler(e, n);
    }, a.prototype.removeOpenChannelHandler = function (e) {
      this._manager.removeHandler(e);
    }, a.prototype.removeAllOpenChannelHandlers = function () {
      this._manager.clearHandler();
    }, a.prototype.buildOpenChannelFromSerializedData = function (e) {
      return this._manager.buildOpenChannelFromSerializedData(e);
    }, a.prototype.getChannel = function (e) {
      return n(this, void 0, void 0, function () {
        return t(this, function (n) {
          return [2, this._manager.getChannel(e)];
        });
      });
    }, a.prototype.getChannelWithoutCache = function (e) {
      return n(this, void 0, void 0, function () {
        return t(this, function (n) {
          return [2, this._manager.getChannelWithoutCache(e)];
        });
      });
    }, a.prototype.createChannel = function (e) {
      return void 0 === e && (e = {}), n(this, void 0, void 0, function () {
        return t(this, function (n) {
          return [2, this._manager.createChannel(e)];
        });
      });
    }, a.prototype.createChannelWithOperatorUserIds = function (e, r, a, i, o) {
      return n(this, void 0, void 0, function () {
        var n;
        return t(this, function (t) {
          return (n = D({}, le)).name = e, n.coverUrlOrImage = r, n.data = a, n.operatorUserIds = i, n.customType = o, [2, this._manager.createChannel(n)];
        });
      });
    }, a;
  }(L);
export { Ne as OpenChannel, Pe as OpenChannelHandler, Oe as OpenChannelListQuery, xe as OpenChannelModule, we as ParticipantListQuery };